export default {
  RECENT (state, value) {
    state.recent = value
  },
  LIST (state, value) {
    state.list = value || []
  },
  LIST_SYSTEM (state, value) {
    state.system = value || null
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push(value)
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  }
}
